import React from 'react';
import { Download } from 'lucide-react';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

const HistoryView = ({ history, t }) => {
  const exportPDF = () => {
    const doc = new jsPDF();
    
    // Header
    doc.setFontSize(20);
    doc.setTextColor(102, 126, 234);
    doc.text('AX-IOM', 20, 20);
    doc.setFontSize(12);
    doc.setTextColor(100);
    doc.text('Historique des recommandations', 20, 30);
    doc.text(`Généré le ${new Date().toLocaleDateString('fr-FR')}`, 20, 38);
    
    // Table
    autoTable(doc, {
      startY: 50,
      head: [['Actif', 'Type', 'Entrée', 'Sortie', 'Résultat', 'Date']],
      body: history.map(h => [
        h.ticker,
        h.type,
        `$${h.entry?.toLocaleString()}`,
        `$${h.exit?.toLocaleString()}`,
        `${h.result > 0 ? '+' : ''}${h.result}%`,
        h.date
      ]),
      theme: 'striped',
      headStyles: { fillColor: [102, 126, 234] },
      styles: { fontSize: 10 }
    });
    
    // Footer
    doc.setFontSize(8);
    doc.setTextColor(150);
    doc.text('© 2025 AX-IOM - Licence 2bintec - 78, av des Champs Elysées, 75008 Paris', 20, doc.internal.pageSize.height - 10);
    
    doc.save('axiom-historique.pdf');
  };

  return (
    <div className="history-card">
      <div className="history-header">
        <span className="history-title">{t.app.history}</span>
        <button className="btn btn-secondary btn-sm" onClick={exportPDF}>
          <Download size={14} /> Export PDF
        </button>
      </div>
      <table className="history-table">
        <thead>
          <tr>
            <th>Actif</th>
            <th>Type</th>
            <th>{t.app.entry}</th>
            <th>Sortie</th>
            <th>Résultat</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {history.map((h, i) => (
            <tr key={i}>
              <td><strong>{h.ticker}</strong></td>
              <td>{h.type}</td>
              <td>${h.entry?.toLocaleString()}</td>
              <td>${h.exit?.toLocaleString()}</td>
              <td>
                <span className={`result-badge ${h.status}`}>
                  {h.result > 0 ? '+' : ''}{h.result}%
                </span>
              </td>
              <td>{h.date}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HistoryView;
